import { Routes, Route, Navigate } from "react-router-dom";

import Layout from "./components/Layout";
import Dashboard from "./views/Dashboard";
import SyncMapping from "./views/SyncMapping";
import NotFound from "./views/NotFound";

export default function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/map" element={<SyncMapping />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Layout>
  );
}
